import { createAsyncThunk } from "@reduxjs/toolkit";
import askaiServices from "../../Services/askaiServices";
import { ResponseMessageHandler } from "../../globals/components/notification";
import { getCreditsDetailByCompanyId } from "../Company/company.action";
export const askAI = createAsyncThunk(
  "Company/getCompanydetails",
  async (data, thunkAPI) => {
    try {
      let res = await askaiServices.askAIcompanyAPI(data);
      thunkAPI.dispatch(getCreditsDetailByCompanyId({}));
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getPdfforAi = createAsyncThunk(
  "Company/getPdfforAi",
  async (data, thunkAPI) => {
    try {
      let res = await askaiServices.getPdfforAiAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
